export default __webpack_public_path__ + "static/media/Arroz-Doce.55c7b470.jpg";